// extracted by mini-css-extract-plugin
module.exports = {"main":"OverlayView_main__yO5vq"};